(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const onCartPage = document.body.classList.contains('template-cart');
  const sectionId = 'bk-cart-drawer';
  const currency = drawer.dataset.currency || 'USD';
  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(Number(cents || 0) / 100);
  let lastFocus = null;

  const showError = (message) => {
    const element = drawer.querySelector('[data-drawer-error]');
    if (!element) return;
    element.textContent = message || '';
    element.hidden = !message;
  };

  const suggest = async () => {
    const slot = drawer.querySelector('[data-drawer-suggest]');
    if (!slot || !slot.dataset.productId) return;
    const inCart = (slot.dataset.inCart || '').split(',');
    for (const intent of ['complementary', 'related']) {
      try {
        const response = await fetch(`${rootUrl}recommendations/products.json?product_id=${slot.dataset.productId}&limit=4&intent=${intent}`);
        if (!response.ok) continue;
        const { products = [] } = await response.json();
        const pick = products.find((item) => item.available && !inCart.includes(`${item.id}`));
        if (!pick) continue;
        const variant = pick.variants.find((item) => item.available) || pick.variants[0];
        slot.textContent = '';
        const label = document.createElement('small');
        label.className = 'bk-drawer-suggest-label';
        label.textContent = 'Add to your order';
        const media = document.createElement('a');
        media.className = 'bk-drawer-media';
        media.href = pick.url;
        if (pick.featured_image) {
          const image = document.createElement('img');
          image.src = `${pick.featured_image}${pick.featured_image.includes('?') ? '&' : '?'}width=160`;
          image.alt = pick.title;
          image.loading = 'lazy';
          media.append(image);
        }
        const name = document.createElement('a');
        name.className = 'bk-drawer-line-title';
        name.href = pick.url;
        name.textContent = pick.title;
        const price = document.createElement('small');
        price.textContent = `${pick.price_varies ? 'From ' : ''}${formatMoney(pick.price)}`;
        const body = document.createElement('div');
        body.className = 'bk-drawer-line-body';
        body.append(name, price);
        let action;
        if (pick.variants.length === 1 && variant) {
          action = document.createElement('button');
          action.type = 'button';
          action.dataset.suggestAdd = variant.id;
          action.textContent = 'Add';
        } else {
          action = document.createElement('a');
          action.href = pick.url;
          action.textContent = 'View';
        }
        action.className = 'bk-drawer-suggest-action';
        slot.append(label, media, body, action);
        slot.hidden = false;
        return;
      } catch (error) {
        // Try the next recommendation type.
      }
    }
  };

  const render = (sections) => {
    const html = sections && sections[sectionId];
    if (!html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-drawer-inner]');
    const inner = drawer.querySelector('[data-drawer-inner]');
    if (fresh && inner) inner.innerHTML = fresh.innerHTML;
    const count = drawer.querySelector('[data-drawer-count]')?.dataset.drawerCount;
    if (count !== undefined) document.querySelectorAll('.bk-cart-count').forEach((element) => { element.textContent = count; });
    suggest();
  };

  const open = () => {
    lastFocus = document.activeElement;
    drawer.inert = false;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.documentElement.classList.add('bk-drawer-lock');
    drawer.querySelector('.bk-drawer-panel')?.focus();
  };

  const close = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    document.documentElement.classList.remove('bk-drawer-lock');
    showError('');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  };

  const request = async (path, body, isForm) => {
    const response = await fetch(`${rootUrl}${path}`, {
      method: 'POST',
      headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
      body
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    return data;
  };

  const change = async (payload, control) => {
    if (control) control.disabled = true;
    try {
      const data = await request('cart/change.js', JSON.stringify({ ...payload, sections: sectionId }));
      if (onCartPage) { window.location.reload(); return; }
      render(data.sections);
    } catch (error) {
      if (onCartPage) { window.location.reload(); return; }
      showError(error.message);
      if (control) control.disabled = false;
    }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (onCartPage || event.defaultPrevented || !(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add(\.js)?$/.test(new URL(form.action, window.location.href).pathname)) return;
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    const label = submit ? submit.textContent : '';
    if (submit) { submit.disabled = true; submit.textContent = 'Adding…'; }
    const data = new FormData(form);
    data.append('sections', sectionId);
    data.append('sections_url', window.location.pathname);
    try {
      const result = await request('cart/add.js', data, true);
      render(result.sections);
      showError('');
      open();
    } catch (error) {
      open();
      showError(error.message);
    } finally {
      if (submit) {
        submit.disabled = false;
        if (submit.textContent === 'Adding…') submit.textContent = label;
      }
    }
  });

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target.closest('[data-drawer-close]')) { event.preventDefault(); close(); return; }
    if (target.closest('.bk-bag-link') && !onCartPage) { event.preventDefault(); open(); return; }
    const quantity = target.closest('[data-line-change]');
    if (quantity) { event.preventDefault(); change({ id: quantity.dataset.lineKey, quantity: Number(quantity.dataset.lineChange) }, quantity); return; }
    const plan = target.closest('[data-line-plan]');
    if (plan) { event.preventDefault(); change({ id: plan.dataset.lineKey, quantity: Number(plan.dataset.lineQty), selling_plan: Number(plan.dataset.linePlan) }, plan); return; }
    const add = target.closest('[data-suggest-add]');
    if (add) {
      event.preventDefault();
      add.disabled = true;
      try {
        const result = await request('cart/add.js', JSON.stringify({ items: [{ id: Number(add.dataset.suggestAdd), quantity: 1 }], sections: sectionId }));
        render(result.sections);
      } catch (error) {
        showError(error.message);
        add.disabled = false;
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  suggest();
})();
